import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private readonly http: HttpClient) { }

  createRole(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/role`, data).pipe(
      tap((response) => response)
    );
  }

  getRoles(params: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/role/roles`, { params: params }).pipe(
      tap((response) => response),
      map((response) => response)

    );
  }

  updateRole(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/role/update`, data).pipe(
      tap((response) => response)
    );
  }

  deleteRole(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/role/delete`, data).pipe(
      tap((response) => response)
    );
  }

}
